"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatRFC3339woZ = void 0;
const date_fns_1 = require("date-fns");
/**
 * RFC3339のZを除外する
 * MSでイベント作るときにZがあるとタイムゾーンが上書きされる問題に
 * 対処するためのもの
 * 2020-06-05T19:30:00.000Z
 * => 2020-06-05T19:30:00.000
 * @param date
 * @returns
 */
const formatRFC3339woZ = (date) => {
    return (0, date_fns_1.formatRFC3339)(date).replace('Z', '');
};
exports.formatRFC3339woZ = formatRFC3339woZ;
//# sourceMappingURL=formatRFC3339woZ.js.map